// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O8Qhn_0aLtxCECd5aVYq{display:inline-block;margin-left:10px;padding:0;cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/components/copy-to-clipboard/copy-to-clipboard.scss"],"names":[],"mappings":"AAAA,sBACI,oBAAA,CACA,gBAAA,CACA,SAAA,CACA,cAAA","sourcesContent":[".plainCopyIcon {\n    display: inline-block;\n    margin-left: 10px;\n    padding: 0;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"plainCopyIcon": `O8Qhn_0aLtxCECd5aVYq`
};
export default ___CSS_LOADER_EXPORT___;
